import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import createLoginSlice, { ILoginSlice } from './createLoginSlice';
import createUserSlice, { IUserSlice } from './createUserSlice';
import createErrorSlice, { IErrorSlice } from './createErrorSlice';
import createAccessTokenSlice, { IAccessTokenSlice } from './createAccessTokenSlice';
import createAccountSummarySlice, { IAccountSummarySlice } from './createAccountSummarySlice';
import createTransactionsCategoriesSlice, { ITransactionsCategoriesSlice } from './createTransactionsCategoriesSlice';
import createActiveTransactionSlice, { IActiveTransactionSlice } from './createActiveTransactionSlice';
import createStatementsListSlice, { IStatementsListSlice } from './createStatementsListSlice';
import createExpensesListSlice, { IExpensesListSlice } from './createExpensesListSlice';
import createUncategorizedTransactionsSlice, { IUncategorizedTransactionsSlice } from './createUncategorizedTransactionsSlice';
import createDashboardSlice, { IDashboardSlice } from './createDashboardSlice';
import createInnerWidthSlice, { IInnerWidthSlice } from './createInnerWidthSlice';
import createInitializeApiSlice, { IInitializeApiSlice } from './createInitializeApiSlice';
import createScheduleCDataSlice, { IScheduleCSlice } from './createScheduleCDataSlice';
import createUserMessageSlice, { IUserMessageSlice } from './createUserMessageSlice';
import createRedirectionSlice, { IRedirectionSlice } from './createRedirectionSlice';
import createInvoicesSlice, { IInvoicesSlice } from './createInvoicesSlice';
import createMailCheckSlice, { IMailCheckSlice } from './createMailCheckSlice';
import createAddBillSlice from '../pages/BillPay/features/AddBill/store/createAddBillSlice';
import { IAddBillSlice } from '../pages/BillPay/features/AddBill/interfaces';
import createBillPaySlice, { IBillPaySlice } from '../pages/BillPay/store';
import createRouterSlice, { IRouterSlice } from './createRouterSlice';
import createVendorSlice, { IVendorSlice } from '../components/VendorManager/store/createVendorSlice';
import createBankTransferSlice, { IBankTransferSlice } from './createBankTransferSlice';
import createInvoiceCreation, { IInvoiceCreation } from '../pages/Invoices/InvoiceCreation/state/createInvoiceCreation';
import createTransactionSlice, { ITransactionsSlice } from '../pages/TransactionsFacelift/state/createTransactionSlice';
import createAccountantObSlice, { IAccountantSlice } from '../pages/AccountantOnboarding/store/createAccountantOnboarding';
import createCategoriesDrawerSlice, { ICategoriesDrawerSlice } from './createCategoriesDrawerSlice';
import createCategorizationWidgetSlice, { ICategorizationWidgetSlice } from './createCategorizationWidgetSlice';
import createMoneyMoveSlice, { IMoveMoneySlice } from './createMoneyMoveSlice';

// This type combine all slices types
export type rootType = IAccountantSlice & ITransactionsSlice & IVendorSlice & IInvoiceCreation & IRouterSlice & IAddBillSlice & ILoginSlice & IUserSlice & IErrorSlice & IAccessTokenSlice & IAccountSummarySlice & ITransactionsCategoriesSlice & IActiveTransactionSlice
  & IStatementsListSlice & IExpensesListSlice & IUncategorizedTransactionsSlice & IDashboardSlice & IInnerWidthSlice & IInitializeApiSlice & IScheduleCSlice & IUserMessageSlice
  & IRedirectionSlice & IInvoicesSlice & IMailCheckSlice & IBillPaySlice & IBankTransferSlice & ICategoriesDrawerSlice & ICategorizationWidgetSlice & IMoveMoneySlice;

export const useStore = create<rootType>()(devtools((set, get) => ({
  ...createLoginSlice(set),
  ...createUserSlice(set, get),
  ...createErrorSlice(set),
  ...createAccessTokenSlice(set, get),
  ...createAccountSummarySlice(set, get),
  ...createTransactionsCategoriesSlice(set, get),
  ...createActiveTransactionSlice(set, get),
  ...createStatementsListSlice(set, get),
  ...createExpensesListSlice(set, get),
  ...createUncategorizedTransactionsSlice(set, get),
  ...createDashboardSlice(set, get),
  ...createInnerWidthSlice(set, get),
  ...createInitializeApiSlice(set, get),
  ...createScheduleCDataSlice(set, get),
  ...createUserMessageSlice(set),
  ...createRedirectionSlice(set, get),
  ...createInvoicesSlice(set, get),
  ...createMailCheckSlice(set),
  ...createAddBillSlice(set),
  ...createBillPaySlice(set, get),
  ...createRouterSlice(set),
  ...createVendorSlice(set, get),
  ...createBankTransferSlice(set, get),
  ...createInvoiceCreation(set),
  ...createTransactionSlice(set, get),
  ...createCategoriesDrawerSlice(set),
  ...createCategorizationWidgetSlice(set),
  ...createAccountantObSlice(set),
  ...createMoneyMoveSlice(set, get),

})));

export default useStore;
